class AddAlertModalController {
  constructor($scope, $uibModalInstance) {
    this.$uibModalInstance = $uibModalInstance
    this.title = ''
  }

  confirm() {
    this.$uibModalInstance.close({ title: this.title })
  }

  cancel() {
    this.$uibModalInstance.dismiss(null)
  }
}

AddAlertModalController.$inject = ['$scope', '$uibModalInstance']

export default AddAlertModalController
